import React, { useState } from 'react';
import css from './FAQPage.module.css';
import classNames from 'classnames';
import { injectIntl, intlShape } from '../../util/reactIntl';

const FAQSection = ({ intl }) => {
  const [activeFAQ, setActiveFAQ] = useState({ section: null, index: null });

  const handleAccordionClick = (section, index) => {
    setActiveFAQ(prevState => {
      if (prevState.section === section && prevState.index === index) {
        return { section: null, index: null };
      }
      return { section, index };
    });
  };

  // Helper to auto-link URLs in descriptions
  const renderDescription = text => {
    if (!text) return null;

    if (text.includes('http://') || text.includes('https://')) {
      const linkedText = text.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
      );
      return <span dangerouslySetInnerHTML={{ __html: linkedText }} />;
    }

    return text;
  };

  const generalFaq = [
    {
      titleId: 'SectionFAQ.general.q1.title',
      descriptionId: 'SectionFAQ.general.q1.description',
    },
    {
      titleId: 'SectionFAQ.general.q2.title',
      descriptionId: 'SectionFAQ.general.q2.description',
    },
    {
      titleId: 'SectionFAQ.general.q3.title',
      descriptionId: 'SectionFAQ.general.q3.description',
    },
    {
      titleId: 'SectionFAQ.general.q4.title',
      descriptionId: 'SectionFAQ.general.q4.description',
    },
    {
      titleId: 'SectionFAQ.general.q5.title',
      descriptionId: 'SectionFAQ.general.q5.description',
    },
    {
      titleId: 'SectionFAQ.general.q6.title',
      descriptionId: 'SectionFAQ.general.q6.description',
    },
  ];

  const subscriptionFaq = [
    {
      titleId: 'SectionFAQ.subscription.q1.title',
      descriptionId: 'SectionFAQ.subscription.q1.description',
    },
    {
      titleId: 'SectionFAQ.subscription.q2.title',
      descriptionId: 'SectionFAQ.subscription.q2.description',
    },
    {
      titleId: 'SectionFAQ.subscription.q3.title',
      descriptionId: 'SectionFAQ.subscription.q3.description',
    },
    {
      titleId: 'SectionFAQ.subscription.q4.title',
      descriptionId: 'SectionFAQ.subscription.q4.description',
    },
    {
      titleId: 'SectionFAQ.subscription.q5.title',
      descriptionId: 'SectionFAQ.subscription.q5.description',
    },
    {
      titleId: 'SectionFAQ.subscription.q6.title',
      descriptionId: 'SectionFAQ.subscription.q6.description',
    },
    {
      titleId: 'SectionFAQ.subscription.q7.title',
      descriptionId: 'SectionFAQ.subscription.q7.description',
    },
    {
      titleId: 'SectionFAQ.subscription.q8.title',
      descriptionId: 'SectionFAQ.subscription.q8.description',
    },
  ];

  const aiCoachFaq = [
    {
      titleId: 'SectionFAQ.aiCoach.q1.title',
      descriptionId: 'SectionFAQ.aiCoach.q1.description',
    },
    {
      titleId: 'SectionFAQ.aiCoach.q2.title',
      descriptionId: 'SectionFAQ.aiCoach.q2.description',
    },
    {
      titleId: 'SectionFAQ.aiCoach.q3.title',
      descriptionId: 'SectionFAQ.aiCoach.q3.description',
    },
    {
      titleId: 'SectionFAQ.aiCoach.q4.title',
      descriptionId: 'SectionFAQ.aiCoach.q4.description',
    },
    {
      titleId: 'SectionFAQ.aiCoach.q5.title',
      descriptionId: 'SectionFAQ.aiCoach.q5.description',
    },
    {
      titleId: 'SectionFAQ.aiCoach.q6.title',
      descriptionId: 'SectionFAQ.aiCoach.q6.description',
    },
    {
      titleId: 'SectionFAQ.aiCoach.q7.title',
      descriptionId: 'SectionFAQ.aiCoach.q7.description',
    },
    {
      titleId: 'SectionFAQ.aiCoach.q8.title',
      descriptionId: 'SectionFAQ.aiCoach.q8.description',
    },
  ];

  const familyProgramFaq = [
    {
      titleId: 'SectionFAQ.familyProgram.q1.title',
      descriptionId: 'SectionFAQ.familyProgram.q1.description',
    },
    {
      titleId: 'SectionFAQ.familyProgram.q2.title',
      descriptionId: 'SectionFAQ.familyProgram.q2.description',
    },
    {
      titleId: 'SectionFAQ.familyProgram.q3.title',
      descriptionId: 'SectionFAQ.familyProgram.q3.description',
    },
    {
      titleId: 'SectionFAQ.familyProgram.q4.title',
      descriptionId: 'SectionFAQ.familyProgram.q4.description',
    },
  ];

  const companiesFaq = [
    {
      titleId: 'SectionFAQ.companies.q1.title',
      descriptionId: 'SectionFAQ.companies.q1.description',
    },
    {
      titleId: 'SectionFAQ.companies.q2.title',
      descriptionId: 'SectionFAQ.companies.q2.description',
    },
    {
      titleId: 'SectionFAQ.companies.q3.title',
      descriptionId: 'SectionFAQ.companies.q3.description',
    },
    {
      titleId: 'SectionFAQ.companies.q4.title',
      descriptionId: 'SectionFAQ.companies.q4.description',
    },
    {
      titleId: 'SectionFAQ.companies.q5.title',
      descriptionId: 'SectionFAQ.companies.q5.description',
    },
  ];

  const hospitalsFaq = [
    {
      titleId: 'SectionFAQ.hospitals.q1.title',
      descriptionId: 'SectionFAQ.hospitals.q1.description',
    },
    {
      titleId: 'SectionFAQ.hospitals.q2.title',
      descriptionId: 'SectionFAQ.hospitals.q2.description',
    },
    {
      titleId: 'SectionFAQ.hospitals.q3.title',
      descriptionId: 'SectionFAQ.hospitals.q3.description',
    },
    {
      titleId: 'SectionFAQ.hospitals.q4.title',
      descriptionId: 'SectionFAQ.hospitals.q4.description',
    },
    {
      titleId: 'SectionFAQ.hospitals.q5.title',
      descriptionId: 'SectionFAQ.hospitals.q5.description',
    },
  ];

  const doctorsFaq = [
    {
      titleId: 'SectionFAQ.doctors.q1.title',
      descriptionId: 'SectionFAQ.doctors.q1.description',
    },
    {
      titleId: 'SectionFAQ.doctors.q2.title',
      descriptionId: 'SectionFAQ.doctors.q2.description',
    },
    {
      titleId: 'SectionFAQ.doctors.q3.title',
      descriptionId: 'SectionFAQ.doctors.q3.description',
    },
    {
      titleId: 'SectionFAQ.doctors.q4.title',
      descriptionId: 'SectionFAQ.doctors.q4.description',
    },
    {
      titleId: 'SectionFAQ.doctors.q5.title',
      descriptionId: 'SectionFAQ.doctors.q5.description',
    },
    {
      titleId: 'SectionFAQ.doctors.q6.title',
      descriptionId: 'SectionFAQ.doctors.q6.description',
    },
    {
      titleId: 'SectionFAQ.doctors.q7.title',
      descriptionId: 'SectionFAQ.doctors.q7.description',
    },
  ];

  const brandsFaq = [
    {
      titleId: 'SectionFAQ.brands.q1.title',
      descriptionId: 'SectionFAQ.brands.q1.description',
    },
    {
      titleId: 'SectionFAQ.brands.q2.title',
      descriptionId: 'SectionFAQ.brands.q2.description',
    },
    {
      titleId: 'SectionFAQ.brands.q3.title',
      descriptionId: 'SectionFAQ.brands.q3.description',
    },
    {
      titleId: 'SectionFAQ.brands.q4.title',
      descriptionId: 'SectionFAQ.brands.q4.description',
    },
    {
      titleId: 'SectionFAQ.brands.q5.title',
      descriptionId: 'SectionFAQ.brands.q5.description',
    },
    {
      titleId: 'SectionFAQ.brands.q6.title',
      descriptionId: 'SectionFAQ.brands.q6.description',
    },
  ];

  const renderFaqList = (sectionKey, items) =>
    items.map((faq, index) => {
      const title = intl.formatMessage({ id: faq.titleId });
      const description = intl.formatMessage({ id: faq.descriptionId });

      if (!title) {
        return null;
      }

      const isActive = activeFAQ.section === sectionKey && activeFAQ.index === index;

      return (
        <div
          key={faq.titleId}
          className={classNames(css.faqCard, {
            [css.activeFAQ]: isActive,
          })}
          onClick={() => handleAccordionClick(sectionKey, index)}
        >
          <div className={css.faqTitle}>
            <span className={css.faqHeading}>{title}</span>
            <span className={css.faqIcon}>{isActive ? '-' : '+'}</span>
          </div>
          {isActive && <div className={css.faqDescription}>{renderDescription(description)}</div>}
        </div>
      );
    });

  return (
    <div className={css.faqSection}>
      <h2>{intl.formatMessage({ id: 'SectionFAQ.general.heading' })}</h2>
      {renderFaqList('general', generalFaq)}

      <h2>{intl.formatMessage({ id: 'SectionFAQ.subscription.heading' })}</h2>
      {renderFaqList('subscription', subscriptionFaq)}

      <h2>{intl.formatMessage({ id: 'SectionFAQ.aiCoach.heading' })}</h2>
      {renderFaqList('aiCoach', aiCoachFaq)}

      <h2>{intl.formatMessage({ id: 'SectionFAQ.familyProgram.heading' })}</h2>
      {renderFaqList('familyProgram', familyProgramFaq)}

      <h2>{intl.formatMessage({ id: 'SectionFAQ.companies.heading' })}</h2>
      {renderFaqList('companies', companiesFaq)}

      <h2>{intl.formatMessage({ id: 'SectionFAQ.hospitals.heading' })}</h2>
      {renderFaqList('hospitals', hospitalsFaq)}

      <h2>{intl.formatMessage({ id: 'SectionFAQ.doctors.heading' })}</h2>
      {renderFaqList('doctors', doctorsFaq)}

      <h2>{intl.formatMessage({ id: 'SectionFAQ.brands.heading' })}</h2>
      {renderFaqList('brands', brandsFaq)}
    </div>
  );
};

FAQSection.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(FAQSection);
